__turbopack_context__.v({
  "actionBlock": "RepairDetailsWatchSidebar-module-scss-module__csPFRG__actionBlock",
  "actionSummary": "RepairDetailsWatchSidebar-module-scss-module__csPFRG__actionSummary",
  "actionSummaryPrice": "RepairDetailsWatchSidebar-module-scss-module__csPFRG__actionSummaryPrice",
  "actionSummaryText": "RepairDetailsWatchSidebar-module-scss-module__csPFRG__actionSummaryText",
  "actions": "RepairDetailsWatchSidebar-module-scss-module__csPFRG__actions",
  "details": "RepairDetailsWatchSidebar-module-scss-module__csPFRG__details",
  "image": "RepairDetailsWatchSidebar-module-scss-module__csPFRG__image",
  "imageWrapper": "RepairDetailsWatchSidebar-module-scss-module__csPFRG__imageWrapper",
  "metaBlock": "RepairDetailsWatchSidebar-module-scss-module__csPFRG__metaBlock",
  "metaGrid": "RepairDetailsWatchSidebar-module-scss-module__csPFRG__metaGrid",
  "metaLabel": "RepairDetailsWatchSidebar-module-scss-module__csPFRG__metaLabel",
  "metaValue": "RepairDetailsWatchSidebar-module-scss-module__csPFRG__metaValue",
  "placeholder": "RepairDetailsWatchSidebar-module-scss-module__csPFRG__placeholder",
  "root": "RepairDetailsWatchSidebar-module-scss-module__csPFRG__root",
  "title": "RepairDetailsWatchSidebar-module-scss-module__csPFRG__title",
  "warrantyBadge": "RepairDetailsWatchSidebar-module-scss-module__csPFRG__warrantyBadge",
  "warrantyBadgeActive": "RepairDetailsWatchSidebar-module-scss-module__csPFRG__warrantyBadgeActive",
  "warrantyBadgeInactive": "RepairDetailsWatchSidebar-module-scss-module__csPFRG__warrantyBadgeInactive",
  "warrantyBlock": "RepairDetailsWatchSidebar-module-scss-module__csPFRG__warrantyBlock",
  "warrantyDates": "RepairDetailsWatchSidebar-module-scss-module__csPFRG__warrantyDates",
  "warrantyRow": "RepairDetailsWatchSidebar-module-scss-module__csPFRG__warrantyRow",
  "watchName": "RepairDetailsWatchSidebar-module-scss-module__csPFRG__watchName",
});
